export const PERMISSION_STATUS = {
  PROMPT: 'prompt',
  GRANTED: 'granted',
  DENIED: 'denied',
};
